<template>
        <div class="checkbox">
            <input :id="name" :name="name" type="checkbox" :value="name" :checked="isChecked ? isChecked : null" @click="sendValue" />
            <label class="checkbox-label" :for="name">
                <div class="checkbox-icon"></div>
                <div v-if="hasUrl" class="checkbox-text" v-html="text"></div>
                <div v-else class="checkbox-text">{{text}}</div>
            </label>
        </div>
</template>

<script>

export default {
    name: 'Checkbox',
    props: {
        name: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        state: {
            type: Boolean,
            default: false
        },
        fullItemData: {
            type: Object,
            default: () => {}
        },
        sendFullData: {
            type: Boolean,
            default: false
        },
        hasUrl: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isChecked: this.state
        };
    },
    methods: {
        sendValue() {
            this.isChecked = !this.isChecked

            if(this.sendFullData) {
                this.$emit('change',{
                    isChecked: this.isChecked,
                    item: this.fullItemData
                });
            } else {
                this.$emit('change', this.isChecked);
            }
        }
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';
.checkbox {
    position: relative;
    @include mobile {
        display: flex;
        align-items: center;
    }
}
input {
    display: none;
}
.checkbox-label {
    display: inline-block;
    padding-left: 0;
    position: relative;
    line-height: normal;
    pointer-events: none;
}
.checkbox label:hover {
    color: #373737;
}
.checkbox-icon {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    border: 3px solid #00abaa;
    cursor: pointer;
    position: absolute;
    pointer-events: auto;
}
.checkbox-text {
    margin-left: 30px;
    font-size: 14px;
    line-height: 22px;
}
.checkbox input:checked+label .checkbox-icon {
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.56578 4.79446L2.71435 2.97875L0.714355 5.02161L4.57721 8.80303L11.2901 2.15875L9.2815 0.127319L4.56578 4.79446Z' fill='%2300ABAA'/%3E%3C/svg%3E%0A");
    background-position: 50%;
    background-repeat: no-repeat;
}
</style>

<style lang="scss">
.checkbox-label a {
    pointer-events: auto;
}
.checkbox-label a {
    color: #00abaa;
}
.checkbox-label a:hover {
    color: #005e5e;
}
</style>
